/* eslint-disable no-multi-assign,no-param-reassign,no-underscore-dangle,@typescript-eslint/no-unused-vars,@typescript-eslint/no-use-before-define,no-var,vars-on-top */

import { ACCOUNTS_CAMPAIGNS_SELECTOR_LIST_TYPE } from '../../../../app/constants/accounts_campaigns_selector_list_type';

xplenty.filter('selectedAccountsFilter');

xplenty.controller('accountsCampaignsSelectorController', [
  '$scope',
  '$timeout',
  '$stateParams',
  '$sce',
  'connectionsService',
  'accountsCampaignsSelectorDataAdapter',
  'accountsCampaignsSelectorSettings',

  function (
    $scope,
    $timeout,
    $stateParams,
    $sce,
    connectionsService,
    accountsCampaignsSelectorDataAdapter,
    accountsCampaignsSelectorSettings,
  ) {
    $scope.$on('fbVersionChanged', function (event, data) {
      $scope.refresh();
    });

    $scope.accountsLoading = false;
    $scope.available = [];
    $scope.LIST_TYPE = ACCOUNTS_CAMPAIGNS_SELECTOR_LIST_TYPE;
    $scope.settings = accountsCampaignsSelectorSettings.getSettings($scope.component);

    let accountsToPopulate = [];

    // var connectionObject;

    const loadAccounts = function () {
      $scope.accountsLoading = true;
      $scope.errors = [];
      accountsCampaignsSelectorDataAdapter.load(
        $scope.component,
        function (adaptedData) {
          $scope.available = adaptedData.available;
          $scope.errors = adaptedData.errors;
          $scope.accountsLoading = false;
          initSelected(false, true);
        },
        accountsToPopulate,
        function (res) {
          if (res.data && res.data.error_message) {
            $scope.errors = [res.data.error_message];
            $scope.accountsLoading = false;
          }
        },
      );
    };

    const clear = function (clearSavedAccounts) {
      accountsToPopulate = [];
      $scope.available = [];
      $scope.selected = [];
      $scope.errors = [];
      if (clearSavedAccounts) accountsCampaignsSelectorDataAdapter.clear($scope.component);
    };

    $scope.$watch(
      'component.connection',
      function (newConnection, oldConnection) {
        // check if watch was called on component init and if so do not clear saved selection
        if (!oldConnection.type || oldConnection.id === newConnection.id) {
          clear(false);
        } else {
          clear(true);
        }
        loadAccounts();
      },
      true,
    );

    var initSelected = function (removeSelection, isInitialLoad) {
      const selected = [];
      const isAnyItemSelected =
        $scope.available &&
        $scope.available.find(
          (account) =>
            account.selected || (account.campaigns && account.campaigns.find((campaign) => campaign.selected)),
        );

      _.each($scope.available, function (account) {
        const hasUnselectedCampaign = _.some(account.campaigns, function (campaign) {
          return !campaign.selected;
        });

        if (hasUnselectedCampaign && account.selected) {
          account.selected = false;
        } else if (!hasUnselectedCampaign && $scope.type === 'analytics' && !removeSelection && !isAnyItemSelected) {
          account.semiSelected = false;
          account.selected = true;
        }
        if (account.selected) {
          account.semiSelected = false;
          const accountClone = _.clone(account);
          const previousItem = $scope.selected.find((item) => accountClone.id === item.id);
          if (previousItem) {
            accountClone.collapsed = previousItem.collapsed;
          }
          selected.push(accountClone);
          accountsToPopulate.push(account.id);
        } else {
          const hasSelectedCampaign = _.some(account.campaigns, function (campaign) {
            return campaign.selected || campaign.semiSelected;
          });
          if (hasSelectedCampaign) {
            account.semiSelected = true;
            if (isInitialLoad) {
              account.collapsed = false;
            }
            const accountClone = _.clone(account);
            accountClone.campaigns = [];
            const previousItem = $scope.selected.find((item) => accountClone.id === item.id);
            if (previousItem) {
              accountClone.collapsed = previousItem.collapsed;
            }
            selected.push(accountClone);
            _.each(account.campaigns, function (campaign) {
              if (campaign.selected) accountClone.campaigns.push(_.clone(campaign));
              else if (campaign.semiSelected) {
                const _campaign = _.clone(campaign);
                _campaign.views = [];
                _.each(campaign.views, function (view) {
                  if (view.selected) _campaign.views.push(_.clone(view));
                });
                accountClone.campaigns.push(_.clone(_campaign));
              }
            });
          } else {
            account.selected = false;
            account.semiSelected = false;
          }
        }
      });
      const adaptedData = {};
      $scope.selected = adaptedData.selected = selected;
      accountsCampaignsSelectorDataAdapter.save($scope.component, adaptedData);
    };

    const loadAccountCampaigns = function (account) {
      account.loading = true;

      accountsCampaignsSelectorDataAdapter.loadAccountCampaigns($scope.component, account, function (campaigns) {
        _.each(campaigns, function (campaign) {
          campaign.selected = account.selected || account.semiSelected;
        });
        if (campaigns.length === 0 && account.semiSelected) {
          account.semiSelected = false;
          account.selected = true;
        }
        account.campaigns = campaigns;
        account.collapsed = true;
        account.loaded = true;
        account.loading = false;
        initSelected();
      });
    };

    $scope.refresh = loadAccounts;

    $scope.setAllSelection = function (selection) {
      if (selection) {
        _.each($scope.available, function (account) {
          if (account.semiSelected) $scope.selectAccount(account); // fixes a semiSelect bug by unselecting and reselecting the account
          if (!account.selected) $scope.selectAccount(account);
        });
        initSelected();
      } else {
        _.each($scope.available, function (account) {
          account.selected = false;
          _.each(account.campaigns, function (campaign) {
            campaign.selected = false;
            if (campaign.semiSelected) campaign.semiSelected = false;
            _.each(campaign.views, function (view) {
              view.selected = false;
            });
          });
        });
        initSelected(true);
      }
    };

    $scope.selectAccount = function (_account) {
      const account = _.find($scope.available, { id: _account.id });

      if (!account.selected && !account.semiSelected) {
        account.selected = true;
      } else if (account.selected && !account.semiSelected && $scope.type !== 'analytics') {
        account.semiSelected = true;
        account.collapsed = false;
        account.selected = false;
      } else {
        account.selected = false;
        account.semiSelected = false;
        _.each(account.campaigns, function (campaign) {
          campaign.selected = false;
          if (campaign.semiSelected) campaign.semiSelected = false;
          _.each(campaign.views, function (view) {
            view.selected = false;
          });
        });
      }

      if (account.campaigns && !account.loaded && $scope.type !== 'analytics') {
        loadAccountCampaigns(account);
      } else {
        if ((account.selected || account.semiSelected) && account.campaigns) {
          if (account.campaigns.length === 0 && account.semiSelected) {
            account.semiSelected = false;
            account.selected = false;
          }
          _.each(account.campaigns, function (campaign) {
            campaign.selected = true;
            _.each(campaign.views, function (view) {
              view.selected = true;
            });
          });
        }

        initSelected(true);
      }
    };

    $scope.selectCampaign = function (_account, _campaign, _view) {
      const account = _.find($scope.available, { id: _account.id });
      const campaign = _.find(account.campaigns, { id: _campaign.id });
      if (!_view) {
        if (campaign.semiSelected) {
          campaign.semiSelected = false;
          campaign.selected = false;
        } else {
          campaign.selected = !campaign.selected;
        }
        _.each(campaign.views, function (view) {
          view.selected = campaign.selected;
        });
      } else {
        const view = _.find(campaign.views, { id: _view.id });
        view.selected = !view.selected;
        campaign.selected = _.all(campaign.views, 'selected');
        if (!campaign.selected) campaign.semiSelected = _.some(campaign.views, 'selected');
        else campaign.semiSelected = false;
      }

      initSelected(true);
    };

    $scope.collapseAccount = function (account) {
      account.collapsed = !account.collapsed;

      if (!account.loaded && $scope.type !== 'analytics') loadAccountCampaigns(account);
    };

    $scope.removeError = function (error) {
      const index = $scope.errors.indexOf(error);
      if (index > -1) $scope.errors.splice(index, 1);
    };
  },
]);
